import { Component, Inject, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { API_BASE_URL_SERVICE } from '../../../kiene-core.config';
import { KieneBackendApiService } from '../../../services/backend-api/kiene-backend-api.service';
import { KieneSession } from '../../../services/local-storage/kiene-session';
import { LocalStorageService } from '../../../services/local-storage/local-storage.service';
import { MessageService } from '../../../services/message-service/message.service';
import { User } from '../benutzer/benutzer';
import { Benutzerprofil } from './mein-profil';
import { LoginService } from '../../../services/user/login.service';
import { KieneUtils } from '../../../utils/KieneUtils';
import { Client } from '../../client/classes/client';

@Component({
    selector: 'kiene-mein-profil',
    templateUrl: './mein-profil.component.html',
    styleUrls: ['./mein-profil.component.scss'],
})
export class MeinProfilComponent implements OnInit {
    @Input('showBackButton') showBackButton = false;

    vvvos: Client[];
    totalPrice: number;

    benutzerprofil = new Benutzerprofil();

    wartzezeitFleischCtrl: FormControl = new FormControl();

    kieneSession: KieneSession;

    constructor(
        @Inject(API_BASE_URL_SERVICE) private readonly apiBaseUrl: string,
        private readonly api: KieneBackendApiService,
        private readonly messageService: MessageService,
        private readonly localStorageService: LocalStorageService,
        private readonly loginService: LoginService,
        private readonly route: ActivatedRoute,
    ) {
        if (this.route.snapshot.data.showBackButton) {
            this.showBackButton = true;
        }
        this.kieneSession = this.localStorageService.getCurrentUser();
        this.checkWartezeitFleisch();
    }

    ngOnInit(): void {
        this.ladeBenutzerprofil();
    }

    ladeBenutzerprofil() {
        this.api.get(`${this.apiBaseUrl}benutzerprofil/read_one_kundenportal.php`).subscribe({
            next: (response: Benutzerprofil) => {
                this.benutzerprofil = response;
            },
            error: err => {
                this.messageService.errorMessage('Profil konnte nicht geladen werden!', err);
            },
        });
    }

    updateBenutzerprofil() {
        this.benutzerprofil.wartezeit_fleisch = this.wartzezeitFleischCtrl.value === true ? 1 : 0;
        this.api
            .updateGeneric(`${this.apiBaseUrl}benutzerprofil/update_kundenportal.php`, this.benutzerprofil)
            .subscribe({
                next: (response: Benutzerprofil) => {
                    this.messageService.infoMessage('Die Änderungen wurden erfolgreich gespeichert!');
                    this.benutzerprofil = response;
                    const cu = this.localStorageService.getCurrentUser();
                    cu.elemente_pro_seite = response.elemente_pro_seite;
                    cu.vorname = response.vorname;
                    cu.nachname = response.nachname;
                    this.localStorageService.setCurrentUser(cu);
                },
                error: err => {
                    this.messageService.errorMessage('Fehler! ', err);
                },
            });
    }

    passwortSpeichern(passwd: string) {
        const user = new User();
        user.benutzer_id = this.kieneSession.benutzer_id;
        user.passwort = passwd;
        this.api.post(this.apiBaseUrl + 'benutzerprofil/update.php', user).subscribe({
            next: () => {
                this.messageService.infoMessage('Passwort wurde erfolgreich aktualisiert!');
            },
            error: error => {
                this.messageService.errorMessage('Fehler! Passwort konnte nicht aktualisiert werden!', error);
            },
        });
    }

    back() {
        history.back();
    }

    private checkWartezeitFleisch(): void {
        this.api.get(this.apiBaseUrl + 'benutzerprofil/read_one.php').subscribe({
            next: (response: Benutzerprofil) => {
                this.wartzezeitFleischCtrl.setValue(KieneUtils.isApiOne(response.wartezeit_fleisch));
            },
            error: error => {
                this.messageService.errorMessage('Fehler beim Laden der Einstellung Wartezeit Fleisch!', error);
            },
        });
    }

    // protected openStripePage() {
    //     this.api.get(this.apiBaseUrl + 'stripe/get_stripe_session.php').subscribe({
    //         next: response => {
    //             window.location.href = response;
    //         },
    //         error: err => {
    //             this.messageService.errorMessage('Fehler beim Laden der Session!', err);
    //         },
    //     });
    // }

    getTextForSubscribeButton() {
        if (this.localStorageService.getCurrentUser().abo_typ === 0) {
            if (this.totalPrice) {
                return 'VetVet abonnieren: ' + this.totalPrice + '€/Monat';
            } else {
                return 'VetVet abonnieren';
            }
        } else {
            return 'Abo Kündigen';
        }
    }

    // changeSubscription() {
    //     this.api.post(this.apiBaseUrl + 'stripe/change_subscription_type.php', null).subscribe({
    //         next: () => {
    //             this.loginService.reloadSession().subscribe(() => {
    //                 this.openStripePage();
    //             });
    //         },
    //         error: err => {
    //             this.messageService.errorMessage('Fehler beim Abo ändern!', err);
    //         },
    //     });
    // }

    calcTotalPrice() {
        for (let vvvo of this.vvvos) {
            console.log(vvvo.freigabe);
        }
        let ownBetriebe = this.vvvos.filter(vvvo => vvvo.freigabe === 0);
        let freigaben = this.vvvos.filter(vvvo => vvvo.freigabe === 1);

        let total = 0;

        let numOnwBetriebe = ownBetriebe.length;
        if (numOnwBetriebe > 0) {
            total += 20;
            numOnwBetriebe--;
        }
        for (let i = 0; i < 4; i++) {
            if (numOnwBetriebe > 0) {
                total += 10;
                numOnwBetriebe--;
            }
        }
        while (numOnwBetriebe > 0) {
            total += 5;
            numOnwBetriebe--;
        }

        total += 5 * freigaben.length;
        this.totalPrice = total;
    }

    private loadVvvos(): void {
        this.api.getAll(this.apiBaseUrl + 'kunde/read.php').subscribe({
            next: betriebe => {
                this.vvvos = betriebe.records.map((b: any) => ({ ...b, subscriptionSelected: true }));
                this.calcTotalPrice();
            },
            error: err => {
                this.messageService.errorMessage('Vvvo´s konnten nicht geladen werden!', err);
            },
        });
    }
}
